// extracted by mini-css-extract-plugin
export default {"container":"ChatHandlePane_container__J+9UY","handleButton":"ChatHandlePane_handleButton__LPN6A","handleText":"ChatHandlePane_handleText__jVnAv"};